// Maßangaben des Charts, allein aus der verfügbaren Breite abgeleitet.
//
// Der Chart hat zwei Hälften mit fester Aufteilung: links die Historie in
// Tagesauflösung, rechts der erwartete Pfad über die gelisteten Meetings. Fest
// deshalb, weil eine durchgehende Zeitskala den Zukunftsteil bei langem Zoom auf
// einen Streifen zusammenquetschen würde.

export interface Layout {
    width: number;
    height: number;
    isNarrow: boolean;
    marginLeft: number;
    marginRight: number;
    innerW: number;
    plotTop: number;
    plotBottom: number;
    stripTop: number;
    stripH: number;
    axisY: number;
    /** x-Position der Trennlinie zwischen Historie und Erwartung */
    split: number;
    histW: number;
    fwdW: number;
}

const MARGIN_TOP = 18;
const MARGIN_BOTTOM = 50;
const MARGIN_RIGHT = 12;
const STRIP_H = 14;
const STRIP_GAP = 10;

export const NARROW_BREAKPOINT = 700;

export function chartHeight(width: number): number {
    return width > 0 && width < NARROW_BREAKPOINT ? 340 : 460;
}

export function computeLayout(width: number): Layout {
    const isNarrow = width > 0 && width < NARROW_BREAKPOINT;
    const height = chartHeight(width);

    const marginLeft = isNarrow ? 42 : 52;
    const innerW = Math.max(240, width - marginLeft - MARGIN_RIGHT);
    const plotBottom = height - MARGIN_BOTTOM - STRIP_H - STRIP_GAP;
    const stripTop = plotBottom + STRIP_GAP;

    const splitRatio = isNarrow ? 0.56 : 0.67;
    const histW = innerW * splitRatio;

    return {
        width,
        height,
        isNarrow,
        marginLeft,
        marginRight: MARGIN_RIGHT,
        innerW,
        plotTop: MARGIN_TOP,
        plotBottom,
        stripTop,
        stripH: STRIP_H,
        axisY: stripTop + STRIP_H,
        split: marginLeft + histW,
        histW,
        fwdW: innerW - histW,
    };
}
